/**
 * 用户service
 */

import {POST,baseURL} from './service.config.js'
import jQuery from 'jquery';//
import {setSign} from "../MD5";
import md5 from 'js-md5'
import axios from "axios";

/**
 * 获取微信授权信息
 * @param code code message
 * @returns {*|Promise<unknown>}
 */
export const getWechatService = code => POST('btrexchange/wechatAuth',{
   code,
});


/**
 * 根据code获取信息
 * @param code
 * @param cb
 */
export const getInfoByCodeService = (code,cb) => {
    jQuery.ajax({
        type:'POST',
        url: baseURL + 'btrexchange/wechatAuth',
        async: false,
        data:{
            code,
        },
        success(data){
            const res = JSON.parse(data);
            if(res.status === 1){
                cb(res.datas);
            }else{
                alert(res.msg);
            }
        },
        error(err){
        },
    });
};

/**
 * 获取阶段返活动，待领余额和可用余额变动
 * @param tel
 * @param cb
 * @returns {*|Promise|Promise<unknown>}
 */
export const getStageBalanceService = (tel,cb) => {
    jQuery.ajax({
        type: 'POST',
        url: baseURL + 'btrbasic/stageBalance',
        async: false,
        data: {
            tel,
        },
        success(data) {
            const res = JSON.parse(data);
            if (res.status === 1) {
                cb(res);
            } else {
                alert(res.msg);
            }
        },
        error(err) {
        },
    });
};
// /**
//  * 获取阶段返活动，待领余额和可用余额变动
//  * @param tel
//  * @returns {*|Promise|Promise<unknown>}
//  */
// export const getStageBalanceService = tel => POST('btrbasic/stageBalance',{
//     tel,
// });

/**
 * 通过tel 和 openid获取信息
 * @param tel
 * @param cb
 */
export const getInfoByOpenIDService = (tel,cb) =>{
    jQuery.ajax({
        type:'POST',
        url: baseURL + 'btrexchange/getUserDetails',
        async: false,
        data:{
            tel,
            sign:setSign('tel=' + tel),
        },
        success(data){
            const res = JSON.parse(data);
            if(res.status === 1){
                cb(res.datas);
            }else{
                alert(res.msg);
            }
        },
        error(err){
            console.log(err);
        },
    });
};

/**
 * 用户注册
 * @param tel 手机号
 * @param password 密码
 * @param code 验证码
 * @returns {*|Promise|Promise<unknown>}
 */
export const userRetrieveService = (tel,password,code) => POST('btrexchange/userRegister',{
    tel,
    code,
    password:md5(password),
});


/**
 * 业务员分享用户注册
 * @param tel 手机号
 * @param password 密码
 * @param code 验证码
 * @param salesId 业务员ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const userSaleRetrieveService = (tel,password,code,salesId) => POST('btrexchange/userShareRegister',{
    tel,
    code,
    password:md5(password),
    saleman_id:salesId,
});


/**
 * 用户登录
 * @param tel
 * @param password
 * @param openid
 * @returns {*|Promise|Promise<unknown>}
 */
export const userLoginService = (tel,password,openid) => POST('btrexchange/userLogin',{
    tel,
    password:md5(password),
    openid,
});


/**
 * 用户支付宝登录
 * @param tel
 * @param password
 * @param openid
 * @returns {*|Promise|Promise<unknown>}
 */
export const userLoginAlipayService = (tel,password) => POST('btrexchange/aliUserLogin',{
    tel,
    password:md5(password),
});


/**
 * 验证用户是否存在
 * @param tel 电话号
 * @returns {Promise | Promise<unknown>}
 */
export const verificationUserService = tel => POST('btrbasic/checkUserTel',{
    tel,
});

/**
 * 退出登录
 * @param userId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getOutService = userId => POST("btrexchange/userGetOut",{uid:userId});


/**
 * 修改用户登录密码
 * @param tel 电话
 * @param pass 密码
 * @param code 验证码
 * @returns {*|Promise|Promise<unknown>}
 */
export const userChangePassService = (tel,pass,code) => POST('btrexchange/changeUserPass',{
    tel,
    password:md5(pass),
    code,
});

/**
 * 获取用户个人信息
 * @param userId 用户ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const getUserInfoService = userId => POST('btrexchange/getUserInfo',{uid:userId});



/**
 * 获取用户消费记录
 * @param userId 用户ID
 * @param type 类型 0：付款记录 1:充值记录 2：余额消费 3：所有记录
 * @returns {*|Promise|Promise<unknown>}
 */
export const getConsumptionService = (userId,type,page,limit) => POST("btrexchange/consumption",{
    uid:userId,
    type,
    page,
    limit,
});


/**
 * 获取用户会员卡列表
 * @param userId
 * @param page
 * @param limit
 * @returns {*|Promise|Promise<unknown>}
 */
export const getUserCardListService = (userId,page,limit) => POST('btrexchange/userMember',{
    uid:userId,
    page,
    limit,
});


/**
 * 获取会员卡商家信息
 * @param userId
 * @param shopId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getCardByShopInfoService = (userId,shopId) => POST('btrexchange/memberShopInfo',{
    uid:userId,
    shop_id:shopId,
});

/**
 * 获取会员消费记录信息
 * @param userId 用户ID
 * @param shopId 商家ID
 * @returns {*|Promise|Promise<unknown>}
 */
export const getUserCardDetailsService = (userId,shopId,page,limit) => POST('btrexchange/memberCardInfo',{
    uid:userId,
    shop_id:shopId,
    page,
    limit,
});


/**
 * 获取会员卡余额
 * @param tel 用户电话号
 * @param shopId 商家ID
 * @returns {*|Promise<unknown>}
 */
export const getUserCardBalanceService = (tel,shopId) => POST('btrexchange/userMemberShop',{
    tel:tel,
    shop_id:shopId,
});

/**
 *红包兑换
 * @param userId 用户ID
 * @param amount 兑换总金额
 * @param goodsId 商品ID
 * @param specId 规格编号
 * @param num 兑换数量
 * @param shopId 商家ID
 * @param tb_balance 淘宝价格
 * @param jd_balance 京东价格
 * @param goodsName 商品名称
 * @param goodsLogo 商品logo
 * @param goodsSpec 商品规格
 * @param unitPrice 商品单价
 * @returns {*|Promise|Promise<unknown>}
 */
export const convertedCommoditiesService = (userId,amount,goodsId,specId,num,shopId,tb_balance,jd_balance,goodsName,goodsLogo,goodsSpec,unitPrice) => POST('btrexchange/convertedCommodities',{
    uid:userId,
    amount:amount / 100,
    goodsid:goodsId,
    goodsspecId:specId,
    num:num,
    shopid:shopId,
    tbbalance:tb_balance,
    jdbalance: jd_balance,
    goodsname:goodsName,
    goodslogo:encodeURIComponent(goodsLogo),
    goodsspec:encodeURIComponent(goodsSpec),
    unitprice:unitPrice,
});


/**
 * 用户兑换记录
 * @param userId 用户ID
 * @param page
 * @param limit
 * @returns {*|Promise|Promise<unknown>}
 */
export const getExchangeListService = (userId,page,limit) => POST('btrexchange/exchange',{
    uid:userId,
    page,
    limit
});


/**
 * 获取问答信息
 * @param type 0用户问题，1业务员问题，2商家问题
 * @returns {*|Promise|Promise<unknown>}
 */
export const getAnswerService = type => POST('btrexchange/questionsList',{
    type,
});

/**
 * 提问问题信息
 * @param leave 0用户问题，1业务员问题，2商家问题
 * @param ask 问题描述
 * @returns {*|Promise|Promise<unknown>}
 */
export const setAskService = (leave,ask) => POST('btrexchange/addQuestion',{
    type:leave,
    questions:ask,
});

/**
 * 新增收货地址
 * @param userId
 * @param addressInfo
 * @returns {*|Promise|Promise<unknown>}
 */
export const setUserAddressService = (userId,addressInfo) => POST('btrbasic/createAddress',{
    uid:userId,
    ...addressInfo,
});

/**
 * 获取用户收货地址
 * @param userId
 * @param type 0所有 1默认地址
 * @returns {*|Promise|Promise<unknown>}
 */
export const getUserAddressListService = (userId,type = 0) => POST('btrbasic/selAddress',{
    uid:userId,
    is_default:type,
});

/**
 * 获取用户要编辑的收货地址
 * @param addressId 收货地址编号
 * @returns {*|Promise|Promise<unknown>}
 */
export const getByAddressIdService = (addressId) => POST('btrbasic/getAddress',{
    id:addressId,
});



/**
 * 删除收货地址
 * @param addressId
 * @returns {*|Promise|Promise<unknown>}
 */
export const deleteAddressService = (addressId) => POST('btrbasic/delAddress',{id:addressId});

/**
 * 用户兑换下单
 * @param userId 用户ID
 * @param goodsId 商品ID
 * @param goodsName 商品名称
 * @param price 商品单价
 * @param num 兑换数量
 * @param total 兑换总价
 * @param goodsSize 商品尺寸
 * @param userAddressId 用户收货地址编号
 * @param remarks 备注信息
 * @returns {*|Promise|Promise<unknown>}
 */
export const doOrderService = (userId,goodsId,goodsName,price,num,total,goodsSize,userAddressId,remarks) => POST('btrgoods/exchangeOnline',{
    uid:userId,
    goods_id:goodsId,
    goods_name:goodsName,
    goods_price:price,
    num,
    amount:total,
    goods_spec:goodsSize,
    address_id:userAddressId,
    remarks:remarks,
});

/**
* 用户兑换下单需要支付邮费
* @param userId 用户ID
* @param goodsId 商品ID
* @param goodsName 商品名称
* @param price 商品单价
* @param num 兑换数量
* @param total 兑换总价
* @param goodsSize 商品尺寸
* @param userAddressId 用户收货地址编号
 * @param remarks 备注信息
 * @param postag 邮费
* @returns {*|Promise|Promise<unknown>}
*/
export const doOrderPostageService = (userId,goodsId,goodsName,price,num,total,goodsSize,userAddressId,remarks,postag,openId) => POST('btrgoods/wxPayPostage',{
    uid:userId,
    goods_id:goodsId,
    goods_name:goodsName,
    goods_price:price,
    num,
    amount:total,
    goods_spec:goodsSize,
    address_id:userAddressId,
    remarks:remarks,
    express_amount:postag,
    openid:openId,
});



/**
 * 获取用户订单列表
 * @param userId 用户ID
 * @param page
 * @param limit
 * @param status -1 全部 0：待发货 1：已发货 2：已收货
 * @returns {*|Promise|Promise<unknown>}
 */
export const getOederListService = (userId,page,limit,status) => POST('btrbasic/onlineSwitching',{
    uid:userId,
    page,
    limit,
    status,
});





/**
 * 修改默认地址
 * @param userId 用户ID
 * @param addressId 地址编号
 * @returns {*|Promise|Promise<unknown>}
 */
export const changeDetailsAddresService = (userId,addressId) => POST('btrbasic/saveDefaultAddress',{
    uid:userId,
    aid:addressId,
});




/**
 * 确认收货
 * @param orderId
 * @returns {*|Promise|Promise<unknown>}
 */
export const confirmCollectService = orderId => POST('btrgoods/is_receivingGoods',{
    did:orderId
});

/**
 * 获取用户签到信息
 * @param userId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getSignInInfoService = userId => POST('btrexchange/signIn',{
    uid:userId,
});

/**
 * 用户签到
 * @param userId
 * @returns {*|Promise|Promise<unknown>}
 */
export const signInService = userId => POST('btrexchange/clickSignIn',{
    uid:userId,
});

/**
 * 签到历史
 * @param userId
 * @param page
 * @param limit
 * @returns {*|Promise|Promise<unknown>}
 */
export const getSignInHistory = (userId,page,limit) => POST('btrexchange/signRecord',{
    uid:userId,
    page,
    limit,
});

/**
 * 签到待领红包直接兑换
 * @param userId
 * @returns {*|Promise|Promise<unknown>}
 */
export const signDirectExchangeService = userId => POST('btrexchange/signDirectExchange',{
    uid:userId,
});


/**
 * 待领红包记录
 * @param userId
 * @param page
 * @param limit
 * @param status 0未返回，1已返回
 * @returns {*|Promise|Promise<unknown>}
 */
export const getWaitingListService = (userId,page,limit,status) => POST('btrbasic/stageRecord',{
    uid:userId,
    page,
    limit,
    status,
});


/**
 * 修改用户提现密码
 * @param tel
 * @param pass
 * @param code 验证码
 * @param userId
 * @returns {*|Promise|Promise<unknown>}
 */
export const userChangePayPassService = (tel,pass,userId,code) => POST('btrexchange/saveUserTxPass',{
    tel,
    user_id:userId,
    code,
    password:md5(pass),
});




/**
 * 用户提现
 * @param userId 用户ID
 * @param price 提现金额
 * @param pass 提现密码
 * @param openId
 * @returns {*|Promise|Promise<unknown>}
 */
export const setDoTxSaleService = (userId,price,pass,openId) => POST('btrexchange/user_tx',{
    user_id:userId,
    amount:price,
    password:md5(pass),
    openid:openId,
    source_status:1,
});





/**
 * 用户提现记录
 * @param userId
 * @param page
 * @param limit
 * @returns {*|Promise|Promise<unknown>}
 */
export const getUserTXListService = (userId,page,limit) => POST('btrexchange/user_tx_record',{
    user_id:userId,
    page,
    limit
});


/**
 * 获取用户可提现金额
 * @param userId
 * @param leave 0 用户 1 业务员 2 商家
 * @returns {Promise | Promise<unknown>}
 */
export const getUserPriceService = (userId,leave) => POST('btrbasic/tx_balance',{
    id:userId,
    level:leave,
});


/**
 * 获取分享商品的信息
 * @returns {Promise | Promise<unknown>}
 */
export const getShareGoodsListService = () => POST('btractivityshare/getShareGoods');


/**
 * 分享填写信息
 * @param userId 分享人ID
 * @param nickname 姓名
 * @param tel 电话
 * @param sex 性别
 * @param age 年龄
 * @param code 验证码
 * @param shopName 店铺名称
 * @param provinceId 省
 * @param cityId 市
 * @param districtId 区
 * @param addressDetails 详细地址
 * @returns {Promise | Promise<unknown>}
 */
export const setShareInfoService = (userId,nickname,tel,sex,age,code,shopName,provinceId,cityId,districtId,addressDetails) => POST('btractivityshare/shareRegister',{
    uid:userId,
    shop_name:shopName,
    province:provinceId,
    city:cityId,
    district:districtId,
    address:addressDetails,
    tel,
    code,
    nickname,
    sex,
    age,
});




/**
 * 获取兑换商品详情信息
 * @param goodsId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShareGoodsInfoService = goodsId => POST('btractivityshare/shareGoodsInfo',{goods_id:goodsId});


/**
 * 获取可用分享人次
 * @param userId
 * @returns {Promise<unknown>}
 */
export const getSelShareNumOrderService = userId => POST('btractivityshare/selShareNumOrder',{
    uid:userId,
});


/**
 * 我的分享列表
 * @param userId
 * @param page
 * @param limit
 * @returns {Promise | Promise<unknown>}
 */
export const getShareListService = (userId,page,limit) => POST('btractivityshare/myShare',{
    uid:userId,
    page,
    limit,
});


/**
 * 获取分享商品的信息
 * @param goodsId
 * @returns {Promise | Promise<unknown>}
 */
export const getShareSpecService = goodsId => POST('btractivityshare/goodSpec',{
    goods_id:goodsId,
});




/**
 * 用户兑换下单
 * @param userId 用户ID
 * @param goodsId 商品ID
 * @param goodsName 商品名称
 * @param price 商品单价
 * @param num 兑换数量
 * @param total 兑换总价
 * @param goodsSize 商品尺寸
 * @param userAddressId 用户收货地址编号
 * @param remarks 备注信息
 * @returns {*|Promise|Promise<unknown>}
 */
export const shareDoOrderService = (userId,goodsId,goodsName,price,num,total,goodsSize,userAddressId,remarks) => POST('btractivityshare/exchangeOnline',{
    uid:userId,
    goods_id:goodsId,
    goods_name:goodsName,
    goods_price:price,
    num,
    amount:total,
    goods_spec:goodsSize,
    address_id:userAddressId,
    remarks:remarks,
});



/**
 * 获取用户分享订单列表
 * @param userId 用户ID
 * @param page
 * @param limit
 * @param status -1 全部 0：待发货 1：已发货 2：已收货
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShareOederListService = (userId,page,limit,status) => POST('btractivityshare/onlineSwitching',{
    uid:userId,
    page,
    limit,
    status,
});


/**
 * 查看分享订单详情
 * @param orderId 订单编号
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShareOrderDetailsService = (orderId) => POST('btractivityshare/switchingDetails',{id:orderId});



/**
 * 查询分享物流信息
 */
export const getShareLogisticsService = (orderId) => POST('btrkdniao/getShareTracesByJson',{
    did:orderId,
});


/**
 * 分享确认收货
 * @param orderId
 * @returns {*|Promise|Promise<unknown>}
 */
export const confirmShareCollectService = orderId => POST('btractivityshare/is_receivingGoods',{
    did:orderId
});


/**
 * 获取我的分享码
 * @param userId
 * @param url
 * @returns {Promise | Promise<unknown>}
 */
export const getShareCodeService = (userId,url) => POST('btractivityshare/getShareQrcode',{
    uid:userId,
    url,
});


/**
 * 获取分享活动结束时间
 * @returns {Promise | Promise<unknown>}
 */
export const getShareDateService = () => POST('btractivityshare/getActivityShare');

//---------------------------------

/**
 * 添加购物车
 * @param userId 用户ID
 * @param goodsId 商品ID
 * @param num 商品数量
 * @param specTitle 商品规格标题
 * @param specInfo 商品规格内容
 * @returns {Promise | Promise<unknown>}
 */
export const setCartService = (userId,goodsId,num,specTitle,specInfo) => POST('btrorder/addShopingCart',{
    uid:userId,
    goods_id:goodsId,
    num:num,
    spec:specTitle,
    spec_details:specInfo,
});


/**
 * 获取我的购物车列表
 * @param userId 用户ID
 * @returns {Promise | Promise<unknown>}
 */
export const getCartListService = userId => POST('btrorder/getShoppingCart',{
    uid:userId,
});

/**
 * 删除购物车信息
 * @param cId 购物车ID 删除多个时ID之间用逗号隔开
 * @returns {Promise | Promise<unknown>}
 */
export const removeCartInfoService = cId => POST('btrorder/delShopingCart',{
    id:cId,
});


/**
 * 改变购物车库存
 * @param cartId 购物车ID
 * @param num 数量
 * @returns {Promise | Promise<unknown>}
 */
export const changeCartStockService = (cartId,num) => POST('btrorder/asShoppingCart',{
    cid:cartId,
    num:num,
});


/**
 * 获取下单信息
 * @param userId 用户ID
 * @param cartId 购物车ID，中间以逗号区分，直接购买时值为 0
 * @param goodsId 商品ID 购物车结算时值为 0
 * @param addressId 收货地址ID
 * @returns {Promise | Promise<unknown>}
 */
export const getConfirmOrderInfoService = (userId,cartId,goodsId,addressId) => POST('btrorder/confirmOrder',{
    uid: userId,
    cid: cartId,
    goods_id: goodsId,
    address_id:addressId || 0,
});


/**
 * 用户下单
 * @param userId 用户ID
 * @param cardId 购物车ID 直接下单值为 0
 * @param goodsId 商品ID 购物车下单值为 0
 * @param addressId 收货地址 ID
 * @param purchaseType 下单方式 0 直接下单；1 购物车下单
 * @param num 购买数量 购物车下单时值为 0
 * @param total 订单总价
 * @param redEnvelopes 使用红包数量
 * @param cash 使用现金数量
 * @param specsTitle 商品规格标题
 * @param specsInfo 商品规格内容
 * @param remarks 备注信息
 * @returns {Promise | Promise<unknown>}
 */
export const placeAnOrderService = (userId,cardId,goodsId,addressId,purchaseType,num,total,redEnvelopes,cash,specsTitle,specsInfo,remarks) => POST('btrorder/doOrder',{
    uid:userId,
    purchase_mode: purchaseType,
    cid:cardId,
    goods_anmout: total,
    use_hb: redEnvelopes,
    use_xj : cash,
    goods_id:goodsId,
    address_id: addressId,
    num:num,
    spec:specsTitle,
    spec_details:specsInfo,
    remarks:remarks,
});


/**
 * 获取订单支付信息
 * @param orderId 订单号
 * @returns {Promise | Promise<unknown>}
 */
export const getOrderPayInfoService = orderId => POST('btrorder/pay_page',{
    order_no: orderId,
});



/**
 * 获取用户收货地址
 * @param userId
 * @param type 0所有 1默认地址
 * @returns {*|Promise|Promise<unknown>}
 */
export const getAddressListService = (userId,type = 0) => POST('btrbasic/selAddress',{
    uid:userId,
    is_default:type,
});


/**
 *获取收货地址详细信息
 * @param addressId 收货地址编号
 * @returns {Promise | Promise<unknown>}
 */
export const getAddressDetailsService = addressId => POST('btrbasic/getAddress',{
    id:addressId,
});


/**
 * 修改收货地址信息
 * @param userId 用户ID
 * @param addressInfo 地址信息
 * @returns {*|Promise|Promise<unknown>}
 */
export const updateAddressService = (userId,addressInfo) => POST('btrbasic/updateAddress',{
    uid:userId,
    ...addressInfo,
});


/**
 * 新增收货地址
 * @param userId
 * @param addressInfo
 * @returns {*|Promise|Promise<unknown>}
 */
export const addAddressService = (userId,addressInfo) => POST('btrbasic/createAddress',{
    uid:userId,
    ...addressInfo,
});


/**
 * 获取我的订单列表
 * @param userId 用户ID
 * @param status 订单状态 -1全部、0待发货、1已发货、2已收货、3已关闭、4待付款
 * @param page 当前页码
 * @param limit 每页显示行数
 * @returns {Promise | Promise<unknown>}
 */
export const getOrderListService = (userId,status,page,limit) => POST('btrorder/myOrder',{
    uid:userId,
    status,
    page,
    limit,
});

/**
 * 查看订单详情
 * @param orderId 订单编号
 * @returns {*|Promise|Promise<unknown>}
 */
export const getOrderDetailsService = (orderId) => POST('btrorder/orderDetails',{id:orderId});


/**
 * 获取物流信息
 * @param orderId 订单编号
 * @returns {Promise | Promise<unknown>}
 */
export const getLogisticsService = orderId => POST('btrkdniao/getNewOrderTracesByJson',{
    did:orderId,
});



/**
 * 确认收货
 * @param orderId
 * @returns {*|Promise|Promise<unknown>}
 */
export const confirmReceiptService = orderId => POST('btrorder/is_receivingGoods',{
    did:orderId
});


/**
 * 订单超时
 * @param orderId 订单ID
 * @returns {Promise | Promise<unknown>}
 */
export const orderOverTimeService = orderId => POST('btrorder/orderOvertime',{
    order_no:orderId
});


/**
 * 获取未支付订单信息
 * @param orderId 订单编号
 * @returns {Promise | Promise<unknown>}
 */
export const getUnpaidOrderInfoService = (userId,orderId) => POST('btrorder/myOrderPay',{
    uid:userId,
    general_order_no:orderId,
});


/**
 * 未支付订单 切换收货地址
 * @param orderId 订单ID
 * @param addressId 收货地址ID
 * @returns {Promise | Promise<unknown>}
 */
export const changeUnpaidOrderAddressService = (orderId,addressId) => POST('btrorder/save_address',{
    address_id:addressId,
    general_order_no:orderId,
});


/**
 * 订单微信支付
 * @param amount 支付金额
 * @param openid 微信openid
 * @param orderId 订单编号
 * @returns {Promise | Promise<unknown>}
 */
export const payOrderWeChatService = (amount,openid,orderId) => POST('btrorder/phoneWebWxPay',{
    amount,
    openid,
    order_no:orderId,
})


/**
 * 支付无现金
 * @param orderId 订单ID
 * @returns {Promise | Promise<unknown>}
 */
export const noCashPaidService = orderId => POST('btrorder/buyGoods',{
    general_order_no:orderId
});


/**
 * 获取会员卡列表
 * @param userId 用户ID
 * @param page 当前页码
 * @param limit 每页显示行数
 * @returns {*|Promise|Promise<unknown>}
 */
export const getCardListService = (userId,page,limit) => POST('btrexchange/userMember',{
    uid:userId,
    page,
    limit,
});

/**
 * 获取会员卡详情
 * @param userId 用户ID
 * @param shopId 商家ID
 * @returns {Promise | Promise<unknown>}
 */
export const getCardDetailsService = (userId,shopId) => POST('btrexchange/memberShopInfo',{
    uid:userId,
    shop_id:shopId,
});


/**
 * 获取会员卡消费记录
 * @param userId 用户ID
 * @param shopId 商家ID
 * @param page 当前页码
 * @param limit 每页显示行数
 * @returns {Promise | Promise<unknown>}
 */
export const getCardConsumeListService = (userId,shopId,page,limit) => POST('btrexchange/memberCardInfo',{
    uid:userId,
    shop_id:shopId,
    page,
    limit,
});


/**
 * 获取我的代金券列表
 * @param userId 用户ID
 * @param page
 * @param limit
 * @returns {Promise | Promise<unknown>}
 */
export const getCashCouponListService = (userId,page,limit) => POST('btrorder/myVoucherList',{
    uid:userId,
    page,
    limit,
});


/**
 * 获取我的代金券总额
 * @param tel
 * @returns {Promise | Promise<unknown>}
 */
export const getCashCouponTotalService = tel => POST('btrexchange/myVoucher',{
    tel,
});


/**
 * 线下支付，微信支付
 * @param shopId 商家ID
 * @param tel 用户电话
 * @param amount 使用现金
 * @param cash 使用代金券
 * @param total 交易总金额
 * @param openid
 * @param type 交易类型  0付款，1充值,2余额消费
 * @returns {Promise | Promise<unknown>}
 */
export const weChatPayService = (shopId,tel,amount,cash,total,openid,type,useshopscan) => POST('btrexchange/underLineWxPay',{
    shop_id:shopId,
    amount,
    tel,
    use_djj:cash,
    total_sum:total,
    openid,
    type,
	useshopscan
});


/**
 * 支付宝支付无现金
 * @param shopId 商家ID
 * @param tel 用户电话
 * @param amount 使用现金
 * @param cash 使用代金券
 * @param total 交易总金额
 * @param type 交易类型  0付款，1充值,2余额消费
 * @returns {Promise | Promise<unknown>}
 */
export const aliPayPayNoMoneyService = (shopId,tel,amount,cash,total,type,useshopscan) => POST('btrexchange/noMoneyAliPay',{
    tel:tel,
    amount:amount,
    shop_id:shopId,
    type,
    use_djj:cash,
    total_sum:total,
	useshopscan
});


/**
 * 确认收货
 * @param orderId
 * @returns {Promise | Promise<unknown>}
 */
export const receivingGoodsService = orderId => POST('btrorder/is_receivingGoods',{
    did:orderId,
});



/**
 * 获取视频分类
 */
export const getVideosCategoryAPI = () => POST('btrbasic/getVideosCategory');
/**
 * 获取视频分类
 */
export const getVideosCategoryPicker = () => POST('btrbasic/getVideosCategoryPicker');

export const doTXAPI = (amount,userTel,typeId,shopId,salemanId,passWord,name) => POST('btrexchange/doTxNew',{
    amount,
    tel:userTel,
    tx_type:typeId,
    shop_id:shopId,
    saleman_id:salemanId,
    password:md5(passWord),
    name,
})

/**
 * 获取我的扫码活动余额
 * @param tel 用户手机号
 * @param shopId
 */
export const getShopScanService = (shopId,userTel) => POST('sdl/getShopScan',{
    shopid:shopId,
    tel:userTel,
});

/**
 * 红包赠送
 */
export const hbtouser = (tel,code,totel,amount) => POST('btrbasic/hbtouser',{
    tel:tel,
    code:code,
    totel:totel,
    amount:amount
});

/**
 * 获取分享二维码
 */
export const getMyShareQrcode = (uid,openid) => POST('btrbasic/getMyShareQrcode',{
    uid,
    openid,
});

/**
 * 成为代理
 */
export const doDlService = (uid,code) => POST('dl/doDl',{
    uid,
    code
});

/**
 * 发起退款申请
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const addRefundService = (uid, amount, name,title,tel,img) => {
	const config = {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	};
	let formData = new FormData();
	formData.append('uid', uid);
	formData.append('amount', amount);
	formData.append('name', name);
	formData.append('title', title);
	formData.append('tel', tel);
	formData.append('img', img);
	return new Promise((resolve, reject) => {
		axios.post('users/addRefund', formData, config).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	});
};

/**
 * 我的退款列表
 */
export const refundListService = (uid) => POST('users/refundList',{
    uid,
});

/**
 * 退款详情
 */
export const refundDetailService = (id) => POST('users/refundDetail',{
    id,
});
